<template>
  <div class="ui-dialog">
    <div class="ui-dialog__overlay" @click="$emit('close')"></div>
    <div class="ui-dialog__content">

      <div v-if="loading">
        <div class="mdl-spinner mdl-js-spinner is-active"></div>
      </div>

      <div v-else>
        <div class="ui-checkbox" v-for="(user, key) in users" :key="key">
          <input type="checkbox" :value="user.id" :id="user.id" :ref="`checkbox-${user.id}`" @change="selectUser(user)">
          <label :for="user.id" v-text="user.username"></label>
        </div>
        <div class="error-message" v-if="errorMessage">
          <p v-text="errorMessage"></p>
        </div>
        <div class="mdl-dialog__actions align--center">
          <button
            type="button"
            class="mdl-button mdl-js-button mdl-button--raised mdl-js-ripple-effect button"
            @click="$emit('close')"
          >
            Cancel
          </button>
          <button
            type="button"
            class="mdl-button mdl-js-button mdl-button--raised mdl-js-ripple-effect mdl-button--colored"
            @click="shareDocument"
          >
            Share
        </button>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  props: {
    documentId: {
      type: String,
      required: true
    }
  },
  data: () => ({
    loading: true,
    users: [],
    selectedUsers: [],
    errorMessage: null
  }),
  methods: {
    getUsersInGroup () {
      window.axios.get('/users/get-users-in-group', {
        params: {
          groupId: this.$store.getters.user.group_id
        }
      })
        .then(response => {
          this.users = response.data
          this.loading = false
        })
    },
    selectUser (user) {
      let input = this.$refs[`checkbox-${user.id}`][0]

      if (input.checked) {
        this.selectedUsers.push(user)
      } else {
        this.selectedUsers = this.selectedUsers.filter(item => item.id !== user.id)
      }
    },
    shareDocument () {
      this.loading = true
      let selectedCount = this.selectedUsers.length
      if (!selectedCount) {
        this.errorMessage = 'Please select a user or users to share this document with.'
        this.loading = false
        return
      }

      if (selectedCount > 1) {
        for (let i = 0; i < selectedCount; i++) {
          window.axios.post('/files/create-association', {
            documentId: this.documentId,
            relatedId: this.selectedUsers[i].id
          }).then(response => {
            if (response.data.protocol41) {
              this.loading = false
              this.$emit('close')
            }
          })
        }
        return
      }

      window.axios.post('/files/create-association', {
        documentId: this.documentId,
        relatedId: this.selectedUsers[0].id
      }).then(response => {
        if (response.data.protocol41) {
          this.loading = false
          this.$emit('close')
        }
      })
    }
  },
  mounted () {
    this.getUsersInGroup()
  }
}
</script>
